import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { RagLoggerService } from '../services/rag-logger/rag-logger.service';
import { StopWatch } from '@reflact/tsutil';

export const httpLoggerInterceptor: HttpInterceptorFn = (req, next) => {
  const ragLogger = inject(RagLoggerService);
  const s: StopWatch = new StopWatch();
  const requestId = crypto.randomUUID();
  const requestInfo = { method: req.method, url: req.url, requestId, reqBody: req.body };
  return next(req).pipe(
    tap(o => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (o?.type == null) {
        ragLogger.measureHook("HttpError", { ...requestInfo, o });
      } else if (o.type == HttpEventType.Sent) {
        s.start();
        ragLogger.measureHook("HttpSend", { ...requestInfo });
      } else if (o.type == HttpEventType.Response) {
        const responseBody: unknown = o.body;
        ragLogger.measureHook("HttpResponse", { ...requestInfo, duration: s.stop(), responseBody, responseStatus: o.status });
      }
    }),
    finalize(() => {
      // console.log(`✅ [END] ${req.method} ${req.url}`);
    })
  );
};
